import React, { createContext, ReactNode, useContext, useState } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';

import ENV from '../../app/constants/env';
import { deviceIdSelector } from '../../app/main/mainSlice';
import { useAppSelector } from '../../app/store/hooks';
import { isJsonString } from '../../components/newHomePage/utils/newHomePageUtils';
import { UseGetFlag } from '../../app/launchDarkly';

// Define the WebSocket URL
const WS_URL = ENV.SYNC_WS_URL;

// Define the context type
interface WebSocketContextType {
  sendMessage: (message: string) => void;
  lastMessage: any;
  connectionStatus: ReadyState;
}

const UpWSContext = createContext<WebSocketContextType>({
  sendMessage: () => { },
  lastMessage: null,
  connectionStatus: ReadyState.UNINSTANTIATED,
});

const UpWSConnect = ({ children }: { children: ReactNode }) => {
  const [messageHistory, setMessageHistory] = useState<MessageEvent<any>[]>([]);
  const deviceId = useAppSelector(deviceIdSelector);
  const { syncup } = UseGetFlag()

  const shouldConnect = deviceId && syncup;

  const { sendMessage, lastMessage, readyState } = useWebSocket(shouldConnect ? WS_URL : null, {
    onOpen: () => {
      console.log('WebSocket connection established.');
      sendMessage(JSON.stringify({
        appId: deviceId,
        data: { type: 'subscribe' }
      }));
    },
    onClose: () => console.log('WebSocket connection closed.'),
    onMessage: (event) => {

      setMessageHistory((prev) => [...prev, event]);
    },
    onError: (event) => console.error('WebSocket error:', event),
    shouldReconnect: (closeEvent) => true,

  });

  const connectionStatus = readyState;

  return (
    <UpWSContext.Provider
      value={{
        sendMessage,
        lastMessage: isJsonString(lastMessage?.data) ? JSON.parse(lastMessage?.data) : lastMessage?.data,
        connectionStatus,
      }}
    >
      {children}
    </UpWSContext.Provider>
  );
};

export const useWebSocketContext = () => {
  const context = useContext(UpWSContext);
  if (context === undefined) {
    throw new Error('useWebSocketContext must be used within a WebSocketProvider');
  }
  return context;
};

export default UpWSConnect;